import { definePreset as g } from "@pandacss/dev";
import { fontsConfig as r, Themes as t, colorSemanticTokens as i, radiusSemanticTokens as k, spacingPrimitives as f, colorPrimitives as l, fontWeightPrimitives as d, spacingSemanticTokens as c, fontSizePrimitives as p, typeFacePrimitives as T, shadows as S, blur as h } from "@huspy/briks-core";
import { buildThemeColors as s } from "../utils/build-theme-colors.mjs";
import { format as o, toPandaObject as b } from "../utils/format.mjs";
import { transformSpacings as m, pixify as e, transformSemanticToken as a, transformFontWeight as u } from "../utils/transform.mjs";
const P = m(k, "radius-"), n = o(e(m(f, "spacing-"))).toToken(), v = o(a(P)).toSemanticToken("spacing"), w = g({
  conditions: {
    light: "[data-color-mode=light] &",
    dark: "[data-color-mode=dark] &"
  },
  theme: {
    extend: {
      tokens: {
        colors: o(b(l)).toToken(),
        fontSizes: o(e(p)).toToken(),
        spacing: n,
        sizes: n,
        fontWeights: o(u(d)).toToken(),
        lineHeights: o(e(r.sansSerif.lineHeight)).toToken(),
        letterSpacings: o(e(r.sansSerif.letterSpacing)).toToken(),
        fonts: o(T).toToken(),
        radii: n,
        shadows: o(S).toToken(),
        blurs: o(h).toToken()
      },
      semanticTokens: {
        colors: s(i, t.rebu),
        spacing: o(a(c)).toSemanticToken("spacing"),
        sizes: o(a(c)).toSemanticToken("spacing"),
        radii: { ...v, full: { value: "9999px" } }
      }
    }
  },
  themes: {
    extend: {
      mortgage: {
        tokens: {
          colors: s(i, t.mortgage)
        }
      },
      bayteca: {
        tokens: {
          colors: s(i, t.bayteca)
        }
      }
    }
  },
  staticCss: {
    themes: ["mortgage", "bayteca"]
  }
});
export {
  w as briksTokensPreset
};
